
<div class="mb-2">
    <a class="btn btn-secondary" [routerLink]="['/tasks']">&lt; Tasks</a>
</div>

<div *ngIf="Task != null; else Loading" class="card">
    <div class="card-header mfp-header">
        <div class="d-flex justify-content-between">
            <h4 class="d-inline-block align-self-center mb-0">{{ Task.TaskID }}</h4>
            <div class="d-inline-block">
                <button class="btn btn-secondary" (click)="EditTask()">Edit</button>
            </div>
        </div>
    </div>
    <div class="card-body">
        <div class="container-fluid">
            <div class="row">
                <div class="col-12 h3 text-center">
                    {{ Task.Name }}
                </div>
                <div class="col-12 col-md-8 offset-md-2 col-lg-4 offset-lg-1">
                    <div class="row my-2">
                        <div class="col-12 col-md-6 fw-bold">
                            Company Name:
                        </div>
                        <div class="col-12 col-md-6">
                            {{ Task.CompanyName }}
                        </div>
                    </div>
                    <div class="row my-2">
                        <div class="col-12 col-md-6 fw-bold">
                            Assigned To:
                        </div>
                        <div class="col-12 col-md-6">
                            {{ Task.AssignedToEmployee.FirstName }}
                            {{ Task.AssignedToEmployee.LastName }}
                        </div>
                    </div>
                </div>
                <div class="col-12 col-md-8 offset-md-2 col-lg-4 offset-lg-2">
                    <div class="row my-2">
                        <div class="col-12 col-md-6 fw-bold">
                            Type:
                        </div>
                        <div class="col-12 col-md-6">
                            {{ Task.TaskType.Name }}
                        </div>
                    </div>
                    <div class="row my-2">
                        <div class="col-12 col-md-6 fw-bold">
                            Status:
                        </div>
                        <div class="col-12 col-md-6">
                            {{ TaskStatusDisplayValues[Task.TaskStatus] }}
                        </div>
                    </div>
                    <div class="row my-2">
                        <div class="col-12 col-md-6 fw-bold">
                            Priority:
                        </div>
                        <div class="col-12 col-md-6">
                            <div *ngIf="Task.TaskPriority" class="d-flex gap-2">
                                <div class="indicator {{PriorityColorMap[Task.TaskPriority.TaskPriorityID] || DefaultPriorityColor}} mr-1"></div>
                                {{ Task.TaskPriority.Name }}
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-12 col-md-8 offset-md-2 col-lg-10 offset-lg-1">
                    <div class="row my-2">
                        <div class="col-12 fw-bold">
                            Notes:
                        </div>
                        <div class="col-12 mt-1">
                            <textarea class="form-control w-100"
                                      [ngStyle]="{'min-height': GetNotesInputHeight()}"
                                      [ngModel]="Task.Notes" disabled></textarea>
                        </div>
                    </div>
                </div>
                <div class="col-12 mt-3">
                    <div class="row">
                        <div class="col-12 col-md-8 offset-md-2">
                            <div class="row align-items-center">
                                <div class="col-12 my-2 fw-bold text-center">
                                    File Attachments:
                                </div>
                                <file-attachment-list
                                    [FileList]="Task.FileAttachments"
                                    [EditMode]="EditMode"
                                    [UploadHandler]="FileUploader()"
                                    [DeleteHandler]="FileDeleter()">
                                </file-attachment-list>
                            </div>
                        </div>
                    </div>
                    <div class="row mt-4">
                        <div class="col-12 text-center">
                            <button type="button"
                                    class="btn btn-secondary"
                                    (click)="EditMode = !EditMode">
                                {{EditMode ? 'Done Editing' : 'Edit Documents'}}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<ng-template #Loading>
    
</ng-template>